export enum ReturnTimeTopicEnum {
  NORMAL = 'normal',
  TRAFFIC_NO_PREMIUM = 'traffic_no_premium',
}

export const TVI_MODE = {
  TVICONNECT: 'TVI connect',
  MANUAL: 'Manual',
  SCHEDULE: 'Schedule',
}

export const TVI_STOPPED_REASON = {
  AUTO_DETECT_NO_MOVEMENT: 'ระบบพักเพราะตรวจไม่พบการใช้งานรถ (โหมด TVI Connect)',
  AUTO_DETECT_MANUAL_NO_MOVEMENT: 'ระบบพักเพราะตรวจไม่พบการใช้งานรถ (โหมด Manual)',
}

export enum TviStatusEnum {
  DRIVING = 'DRIVING',
  IDLE = 'IDLE',
  STANDBY = 'STANDBY',
  TRAFFIC = 'TRAFFIC',
  CHARGING = 'CHARGING',
  NO_SIGNAL = 'NO_SIGNAL',
  NOT_IN_USE = 'NOT IN USE',
}

export const TVI_STATUS_COLORS: Record<TviStatusEnum, string> = {
  [TviStatusEnum.DRIVING]: '#20B857',
  [TviStatusEnum.IDLE]: '#FF8F00',
  [TviStatusEnum.STANDBY]: '#0290FF',
  [TviStatusEnum.TRAFFIC]: '#FF3511',
  [TviStatusEnum.CHARGING]: '#64FFDA',
  [TviStatusEnum.NO_SIGNAL]: '#5925DC',
  [TviStatusEnum.NOT_IN_USE]: '#666666',
}

export const TVI_STATUS_TEXTS: Record<TviStatusEnum, string> = {
  [TviStatusEnum.DRIVING]: 'Driving',
  [TviStatusEnum.IDLE]: 'Idle',
  [TviStatusEnum.STANDBY]: 'Standby',
  [TviStatusEnum.TRAFFIC]: 'Traffic',
  [TviStatusEnum.CHARGING]: 'Charging',
  [TviStatusEnum.NO_SIGNAL]: 'No-Signal',
  [TviStatusEnum.NOT_IN_USE]: 'Not in use',
}

export const TVI_STATUS_TOOLTIP: Record<TviStatusEnum, string> = {
  [TviStatusEnum.DRIVING]: 'ใช้งานรถด้วยความเร็วมากกว่า 10 km/h',
  [TviStatusEnum.IDLE]:
    'รถหยุดหรือใช้งานรถด้วยความเร็วต่ำกว่า 10 km/h โดยไม่เข้าเงื่อนไขโครงการรถติดไม่คิดเบี้ย',
  [TviStatusEnum.STANDBY]: 'ดับเครื่องแต่ประกันไม่ปิดทันที',
  [TviStatusEnum.TRAFFIC]: 'รถติดตามเงื่อนไฃโครงการรถติดไม่คิดเบี้ย',
  [TviStatusEnum.CHARGING]:
    'เข้าเงื่อนไขที่จะคืนชั่วโมงเนื่องจากลูกค้ามีการเสียบอุปกรณ์สำหรับการชาร์จแบตอุปกรณ์',
  [TviStatusEnum.NO_SIGNAL]: 'อยู่ในพื้นที่อับสัญญาณ (no signal)',
  [TviStatusEnum.NOT_IN_USE]: 'ไม่มีการใช้งานรถ หรือไม่มีข้อมูลจากอุปกรณ์',
}

export const HISTORY_CAR_USAGE_PAGINATION_LIMIT = 15
